import type { MarketExceptionType } from '../../MarketExceptionTypes'
import { Common } from '../Common/Common'

export const JP: MarketExceptionType = {
  ...Common,
  hasNativeCreditCard: true,
  hasStoreCredit: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  disableMixedOrders: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: false,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  currencyCode: 'JPY',
  creditCardProvidersSupported: ['VI', 'MC', 'JCB'],
  blockedCreditCardTypes: [
    {
      errorMessage: 'amex_not_accepted',
      cardType: 'american-express',
    },
  ],
  isPickupMarket: true,
  hasAddressRegion: true,
  supportsStoreCredit: true,
  isWorldPay3DS: true,
  allowSubscriptionPickup: false,
  hasProductAvailability: true,
  skuAvailabilityShippingMethod: 'Economy',
  defaultEconomyShippingMethod: 'Economy',
  tax: {
    inclusive: true,
    noFrontendTaxCalculation: true,
    explicitlyExclusive: false,
  },
  isHostedPayments: true,
  hasBankWire: true,
  skuPricingOverrides: [],
  storeCreditEligibleCustomerTypes: [
    'Customer',
    'Member',
    'Associate',
    'Family',
    'PreferredCustomer',
    'WholesaleCustomer',
  ],
  shippingMethodsHidden: [
    {
      shippingMethodType: 'Economy',
      location: 'MK',
    },
  ],
  quickLinks: {
    helpCenterBaseUrl: null,
    libraryBaseUrl: 'https://ushop.unicity.com/japan/news',
    officeBaseUrl: 'https://ushop.unicity.com/japan/genealogy/dashboard',
    becomeAffiliateUrl: 'https://ushop-link.unicity.com/japan/enroll/',
  },
  addressFormConfig: [
    { field: 'zip', required: true },
    { field: 'state', required: true },

    { field: 'country', required: true },
    { field: 'city', required: true },

    { field: 'address2', required: false },
    { field: 'address1', required: true },

    { field: 'lastName', required: true },
    { field: 'firstName', required: true }, // Adding empty helps to get the desired grid layout
  ],
  addressDisplayOrder: {
    line1: [
      { field: 'zip' },
      { field: 'state', addComma: true },
      { field: 'country' },
      { field: 'city', addComma: true },
    ],
    line2: [{ field: 'address2' }],
    line3: [{ field: 'address1' }],
    line4: [{ field: 'lastName' }, { field: 'firstName' }],
  },
  personalDetailsFormConfig: [
    { field: 'firstName', required: true, disabled: true },
    { field: 'lastName', required: true, disabled: true },
    { field: 'email', required: true, disabled: false },
    { field: 'phone', required: true, disabled: true },
  ],
  removeSmsPasswordRecovery: true,
  hideTopUpCommissionPeriodSelector: true,
}
